module.exports = __webpack_public_path__ + "img/check.26cc3e6e.svg";